import React, {Fragment} from 'react';
import {connect} from "react-redux";
import first from "lodash/first";
import {FormattedMessage} from "react-intl";

import {setShowJobEditPopup, setShowJobPaymentPopup} from "../../actions/A_Popups";
import JobBoardRecalculateButton from "./JobBoardRecalculateButton";
import * as helpers from "../../utilities/helpers";

const getJobPaidStatus = (job) => {
  if (job.paid) { // todo
    return "jobBoard.paid"
  }
  if (job.remaining) {
    return "jobBoard.remaining"
  }
  return "jobBoard.quote"
}

const JobBoardJobTotal = (props) => {

  const {job, setShowJobPaymentPopup, setShowJobEditPopup} = props;

  if (job.jobIdType === 'Lead') {
    return null
  }

  const jobPaymentClick = () => {
    console.log("job", job);
    setShowJobPaymentPopup(true, job);
  }

  const getCurrencySymbol = () => {
    let currencySymbol = "$";
    const q = first(job.quotes);
    if (q && q.currency) {
      currencySymbol = helpers.getCurrencySymbol(q.currency);
    }

    return currencySymbol;
  }

  const getJobTotal = () => {
    return getCurrencySymbol(job) + (job.grandTotal || 0).toFixed(2)
  }

  const jobTotalRender = () => {
    if (!job.anotherCurrencies) {
      if (job.grandTotal === -1) {
        return "----"
      }
      return getJobTotal()
    }
    const parsed = JSON.parse(job.anotherCurrencies);
    const hasSomeCurrenciesWithTotal = parsed.some(currObject => currObject.total);
    return (
      <Fragment>
        {hasSomeCurrenciesWithTotal && !job.grandTotal ? null : getJobTotal()}
        {hasSomeCurrenciesWithTotal ? parsed.map(currObject => {
          return <div key={currObject.currency}>{currObject.currency + currObject.total}</div>
        }) : null}
      </Fragment>
    )
  }

  return (
    <div className="job-board-items">
      <FormattedMessage id={getJobPaidStatus(job)}/>
      {job.markUpLogic && job.markUpLogic.includes('isUpdatedInJobBoard') ? null : (
        // <div className="job-board-green bold link link--green" onClick={jobPaymentClick}>
        <div className="job-board-green">
          {jobTotalRender()}
        </div>
      )}
      {/*<div className="bold link link--green"*/}
      {/*     onClick={() => setShowJobEditPopup(true, job)}>open edit*/}
      {/*</div>*/}
      <JobBoardRecalculateButton job={job}/>
    </div>
  )
};

const mapStateToProps = () => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
  };
};

const mapDispatchToProps = {
  setShowJobPaymentPopup,
  setShowJobEditPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobBoardJobTotal)
